import { createContext } from "react";

export const DictionaryContext = createContext()